// extracted by mini-css-extract-plugin
export default {"subCut":"SubCat_subCut__jzqTn","subCutOpen":"SubCat_subCutOpen__uNl0l","not_active":"SubCat_not_active__EQ1mU","active":"SubCat_active__XKGcv"};